import _ from 'lodash';
import { debounce } from 'lodash';
import { getRefreshToken } from 'src/store/slices/user';

// 함수 정의
export const checkTokenAndRefresh = async (dispatch) => {
  let accessToken = window.localStorage.getItem('accessToken');

  if (isEmpty(accessToken)) {
    accessToken = await dispatch(getRefreshToken());
    try {
      return accessToken;
    } catch (error) {
      console.log('error', error.response);
    }
  }
  return accessToken;
};

// 휴대전화번호가 11자이면 하이픈 추가
export const formatPhoneNumber = (value = '') => {
  if (value.length <= 3) return value; // 3자 이하일 때 그대로 반환
  if (value.length <= 7) {
    // 3-4 형태
    return value.replace(/(\d{3})(\d{1,4})/, '$1-$2');
  }
  // 3-4-4 형태
  return value.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3');
};

// 값이 비어있는지 확인
export const isEmpty = (data) => {
  if (typeof data === 'string') data = data.trim();
  const emptyType = [undefined, null, NaN, false];
  const emptyString = ['undefined', 'null', 'NaN', 'false', ''];
  const emptyArray = [...emptyType, ...emptyString];

  if (typeof data === 'object') {
    return _.isEmpty(data) ? true : false;
  } else {
    return emptyArray.includes(data) ? true : false;
  }
};
// 공지사항 안읽음것부터 넣는 함수
export const sortIsRead = (arr) => {
  const sortedArray = arr?.sort((a, b) => {
    // false인 것들이 앞에 오도록 정렬
    if (!a.isRead && b.isRead) {
      return -1;
    }
    // true인 것들이 나중에 오도록 정렬
    if (a.isRead && !b.isRead) {
      return 1;
    }
    // 나머지 경우는 순서를 유지
    return 0;
  });
  return sortedArray;
};

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);

// 에러 핸들
export const errorHandle = (error) => {
  const code = error?.code;
  const message = error?.message;
  const detail = error?.errorDetail;

  // 시스템, 커스텀 에러 병합
  const systemError = { code, message, detail };
  const customError = error?.response?.data?.error;
  if (customError?.code === 'E056533') {
    customError.message = '이름 혹은 연락처를 확인해주세요.';
  }

  const errorData = Object.assign(systemError, customError);

  return errorData;
};

// 값이 있느지 확인

export const isExist = (data) => {
  if (typeof data === 'string') data = data.trim();
  const emptyType = [undefined, null, NaN, false];
  const emptyString = ['undefined', 'null', 'NaN', 'false', ''];
  const emptyArray = [...emptyType, ...emptyString];

  if (typeof data === 'object') {
    return !_.isEmpty(data) ? true : false;
  } else {
    return !emptyArray.includes(data) ? true : false;
  }
};

// 객체형태를 배열로
export const convertObjectToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => ({ key, value }));
};

export function limitedApiCall(dispatch, actions) {
  const lastCall = localStorage.getItem('lastApiCallTime');
  const now = new Date().getTime();
  const interval = 60000; // 간격 1분

  if (!lastCall || now - lastCall > interval) {
    actions.forEach((actionOrObject) => {
      // actionOrObject이 함수인지 객체인지에 따라 다르게 처리
      if (typeof actionOrObject === 'function') {
        // 직접 함수가 전달된 경우
        dispatch(actionOrObject());
      } else if (typeof actionOrObject === 'object' && actionOrObject !== null) {
        // 객체가 전달된 경우
        const { action, params = [] } = actionOrObject;
        dispatch(action(...params));
      }
    });
    localStorage.setItem('lastApiCallTime', now.toString());
  }
}

// formik input value 입력 했는 지 확인
export function allPropertiesFilled(obj, isArray = false) {
  return Object.values(obj).every((value) => {
    if (isArray) {
      // 값이 null, undefined, 빈 문자열이 아닌지 확인
      const isNotNullOrUndefinedOrEmptyString = value !== null && value !== undefined && value !== '';

      // 특정 속성값만 배열인 경우, 그 배열이 비어 있지 않아야 함
      const isArrayNotEmpty = Array.isArray(value) ? value.length > 0 : true;

      return isNotNullOrUndefinedOrEmptyString && isArrayNotEmpty;
    } else {
      const isNotNullOrUndefinedOrEmptyString = value !== '';
      return isNotNullOrUndefinedOrEmptyString;
    }
  });
}

// 상태 뒤 메시지 제거 함수
export function removeMessageFromString(str) {
  return str.replace('Message', '');
}
//  api 호출 1분 간격으로 제한
export const debouncedApiCall = debounce((dispatch, action, params = []) => {
  dispatch(action(...params));
}, 60000); // 1분 동안 재호출 방지

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    // 0에서 i 사이의 무작위 인덱스를 선택합니다
    const j = Math.floor(Math.random() * (i + 1));
    // 현재 요소와 선택된 요소를 교환합니다 (구조 분해 할당을 사용)
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

// 파일이 이미지인지 확인하는 함수
export const isImageFile = (fileName) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
  const extension = fileName.split('.').pop().toLowerCase();
  return imageExtensions.includes(extension);
};

// 파일이 문서인지 확인하는 함수
export const isDocumentFile = (fileName) => {
  const documentExtensions = ['pdf', 'hwp', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
  const extension = fileName.split('.').pop().toLowerCase();
  return documentExtensions.includes(extension);
};

// 배열 끼리 비교
export const arraysAreEqual = (array1, array2) => {
  if (array1.length !== array2.length) return false; // 길이가 다르면 false
  return array1.every((value, index) => value === array2[index]); // 모든 값이 동일한지 확인
};

export const getPercentage = (price, carPrice) => {
  const validPercentages = [10, 20, 30, 40, 50];
  const percentage = (price / carPrice) * 100;

  // price를 숫자형으로 변환 후 toLocaleString 적용
  const formattedPrice = Number(price).toLocaleString('en-US');

  if (validPercentages.includes(Math.round(percentage))) {
    return `${Math.round(percentage)}%/${formattedPrice}원`;
  } else {
    return `직접입력/${formattedPrice}원`;
  }
};

// 로그인 페이지 이동(with RN)
export const navigateToLogin = (navigate, state = {}) => {
  return isMobile ? window.ReactNativeWebView?.postMessage('navigationToLogin') : navigate('/login', state);
};

// 채널 메시지 초기화 함수
export const initializeChannelMessageState = () => ({
  docs: [],
  total: 0,
  page: 1,
  pages: 1,
  limit: 10
});

// 메시지 병합 및 중복 제거 함수
export const mergeMessages = (existingDocs, newDocs) => {
  const messageMap = new Map(existingDocs.map((item) => [item._id, item]));
  newDocs.forEach((newItem) => {
    messageMap.set(newItem._id, {
      ...messageMap.get(newItem._id), // 기존 메시지 데이터
      ...newItem // 새로운 메시지 데이터로 업데이트
    });
  });
  return Array.from(messageMap.values());
};

//  CreatedAt 순서로 정렬 함수
export const sortByCreatedAt = (messages) => {
  return messages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
};
